<template>
  <div>
    <div class="mt-4 mx-2">
      <v-row class="">
        <v-col md="6">
          <div class="text-h5 ml-3 float-left" >
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small @click="recalc()" v-bind="attrs" fab class="neu-glow float-left mr-5" active-class="neu-glow-inset" v-on="on" :loading="loading">
                  <v-icon 
                    large
                    color="info"
                    class="mx-3"
                    active-class="neu-glow-inset"
                    >
                      mdi-sync-circle
                  </v-icon>
                </v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>
            Messaggi: {{tab==0?items?items.length:'':itemsAnalysis?itemsAnalysis.length:''}}
          </div>
        </v-col>
        <v-col cols="6" class="text-right pr-8">
          <v-btn @click="dialog_range=true">Periodo {{rangeString}}</v-btn>
        </v-col>
      </v-row>
      <v-row v-if="!items&&!expired">
        <v-col cols="12">
          <v-card-text>
            <v-card style="padding-top:6%" :height="wHeight-250" class="text-center">
                <v-progress-circular
                  :size="wHeight-450"
                  width="35"
                  color="info"
                  indeterminate
                ></v-progress-circular>
            </v-card>           
        </v-col>
      </v-row>
      <v-row v-else>        
        <v-col cols="12" class="pt-0">
          <v-card class="neu-glow ma-4 pa-4">
            <v-row>
              <v-col>
                <v-alert
                  class="float-left mb-0"
                  v-if="expired.showAlert"
                  :max-width="750"
                  text
                  dense
                  transition="scale-transition"
                  type="error"
                >
                  <v-row
                    align="center"
                    no-gutters
                  >
                    <v-col v-if="expired.expired" class="grow font-weight-bold">
                      Modulo Scaduto il {{expired.expiry}}: Vai al carrello per riattivarlo
                    </v-col>
                    <v-col v-else class="font-weight-bold">
                      Questo Modulo scade il {{expired.expiry}}: Vai al carrello per Estenderne la durata
                    </v-col>
                    <v-col class="shrink font-weight-bold pl-8">
                      <v-btn
                        small
                        to='/shop'
                        color="info"                            
                      >
                        Estendi
                      </v-btn>
                    </v-col>
                  </v-row>                    
                </v-alert>  
              </v-col>
            </v-row>            
            <v-row dense>
              <v-col> 
                <v-tabs
                  v-model="tab"
                  align-with-title
                >
                  <v-tabs-slider color="info"></v-tabs-slider>
        
                  <v-tab
                    v-for="(t,i) in ['WhatsApp','Analisi Mensile']"
                    :key="i"
                  >
                    {{ t }}
                  </v-tab>
                </v-tabs>
              </v-col>
              <v-col  v-if="itemsAnalysis&&search" class="ma-1 neu-glow-inset px-4 pt-3 text-center">
                Messaggi: {{itemsAnalysis.find(m=>m.type==search)?itemsAnalysis.find(m=>m.type==search).cnt:0}} di cui Fatturabili: {{itemsAnalysis.find(m=>m.type==search)?itemsAnalysis.find(m=>m.type==search).tot:0}}
              </v-col>
              <v-col v-else-if="itemsAnalysis" class="ma-1 neu-glow-inset px-4 pt-3 text-center">
                Messaggi: {{itemsAnalysis.length}} di cui Fatturabili: {{itemsAnalysis.reduce((sum, item) => sum + item.payable, 0)}}
              </v-col>
              <v-col class="my-1 grey darken-4">
                <v-tooltip top v-if="tab>0">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on"  icon color="info" class="neu-glow mx-2 mt-1" @click="dialog_summary=1"><v-icon>mdi-sigma</v-icon></v-btn> 
                  </template>
                  <span>Riepilogo (lento)</span>
                </v-tooltip>
                <v-text-field v-if="tab<1"
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Cerca:"
                  color="info"
                  single-line
                  hide-details
                  class="float-right mt-n2"
                  style="max-width:250px"
                ></v-text-field>
                <v-select
                  v-else
                  dense
                  clearable
                  v-model="search"
                  :items="templateTypes"
                  label="Tipo Messaggio"
                  hide-details
                  outlined
                  class="float-right"
                  style="width:450px"
                ></v-select>               
              </v-col>                  
              <v-col cols="12"> 
                <v-tabs-items v-model="tab">
                  <v-tab-item
                    key="0"
                  >
                    <v-row>
                      <!--
                      <v-col cols="12">         
                        <v-text-field
                          v-model="search"
                          append-icon="mdi-magnify"
                          label="Cerca:"
                          color="info"
                          single-line
                          hide-details
                          class="float-right mt-n2"
                          style="max-width:250px"
                        ></v-text-field>                      
                      </v-col>  
                      -->            
                      <v-col cols="12">
                        <v-data-table
                          dense
                          fixed-header
                          :headers="headers"
                          :items="items||[]"
                          hide-default-footer
                          :items-per-page=50000
                          :height="wHeight-235"
                          :loading="loading"
                          :search="search"  
                          :custom-filter="customSearch"
                          multi-sort
                          no-data-text="Nessun dato presente in archivio"
                          no-results-text="Nessun Risultato estratto"
                          loading-text="Consultazione archivio: attendi..."
                          item-key="messageId"
                        >

                          <template v-slot:[`item.type`]="{ item }">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    v-bind="attrs" 
                                    v-on="on"                                
                                    color="info"
                                  >
                                    {{item.icon}}
                                  </v-icon>                
                              </template>
                              <span>{{item.message}}</span>
                            </v-tooltip>
                          </template>


                          <template v-slot:[`item.rn`]="{ item }">
                            {{item.category=='marketing'?1:item.rn}}
                          </template> 


											<template v-slot:[`item.lastName`]="{ item }">
                        <div class="text-uppercase">{{item.firstName?item.lastName+' '+item.firstName:item.lastName?item.lastName:item.fullName}}</div>
											</template>



                          <template v-slot:[`item.bookingDate`]="{ item }">
                            {{new Intl.DateTimeFormat('it-IT',{ day:'2-digit',month:'2-digit',year:'numeric' }).format(new Date(item.bookingDate))}}
                          </template> 

                          <template v-slot:[`item.statusIcon`]="{ item }">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    v-bind="attrs" 
                                    v-on="on"                                
                                    :color="item.statusIconColor"
                                  >
                                    {{item.statusIcon}}
                                  </v-icon>                
                              </template>
                              <span>{{item.statusName}} {{item.error_message?': '+item.error_message:''}}</span>
                            </v-tooltip>

                          </template> 

                                               

                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <!--
                  <v-tab-item
                    key="1"
                  >
                    <v-row>
                      <v-col cols="12">
                        <v-data-table
                          dense
                          fixed-header
                          :headers="headersSMS"
                          :items="itemsSMS||[]"
                          hide-default-footer
                          :items-per-page=500
                          :height="wHeight-235"
                          :loading="loading"
                          :search="search"  
                          multi-sort
                          no-data-text="Nessun dato presente in archivio"
                          no-results-text="Nessun Risultato estratto"
                          loading-text="Consultazione archivio: attendi..."
                          item-key="messageId"
                        >

                          <template v-slot:[`item.type`]="{ item }">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    v-bind="attrs" 
                                    v-on="on"                                
                                    color="info"
                                  >
                                    {{item.icon}}
                                  </v-icon>                
                              </template>
                              <span>{{item.message}}</span>
                            </v-tooltip>
                          </template>

                          <template v-slot:[`item.TS`]="{ item }">
                            {{new Intl.DateTimeFormat('it',{ day:'2-digit',month:'2-digit',year:'numeric' }).format(new Date(item.TS))}}
                          </template> 

                          <template v-slot:[`item.statusIcon`]="{ item }">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    v-bind="attrs" 
                                    v-on="on"                                
                                    :color="item.statusIconColor"
                                  >
                                    {{item.statusIcon}}
                                  </v-icon>                
                              </template>
                              <span>{{item.statusName}} {{item.error_message?': '+item.error_message:''}}</span>
                            </v-tooltip>

                          </template> 

                          <template v-slot:[`item.amount`]="{ item }">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <div v-bind="attrs" v-on="on" >
                                  <i :class="'mr-3 em em-flag-'+ item.country" v-if="item.status!='failed'&&item.rn==1"></i>
                                  {{item.status!='failed'&&item.rn==1?item.price:''}}
                                </div>
                              </template>
                              <span>{{item.countryName}}</span>
                            </v-tooltip>

                          </template>                                                          

                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  -->
                  <v-tab-item
                    key="1"
                  >
                    <v-row>         
                      <v-col cols="12">
                        <v-data-table
                          dense
                          fixed-header
                          :headers="headers2"
                          :items="itemsAnalysis||[]"
                          hide-default-footer
                          :items-per-page=50000
                          :height="wHeight-235"
                          :loading="loading"
                          :search="search"  
                          multi-sort
                          no-data-text="Nessun dato presente in archivio"
                          no-results-text="Nessun Risultato estratto"
                          loading-text="Consultazione archivio: attendi..."
                          item-key="messageId"
                        >
                          <template v-slot:[`item.date`]="{ item }">
                            {{new Intl.DateTimeFormat(settings.locale||'it',{ day:'2-digit',month:'2-digit',year:'numeric' }).format(new Date(item.date))}}
                          </template>                         
                          <template v-slot:[`item.conversation_id`]="{ item }">
                            {{item.conversation_id?item.conversation_id.slice(6):''}}
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-tab-item>                  
                </v-tabs-items>
              </v-col>    
            </v-row>
          </v-card>
        </v-col> 
      </v-row>
    </div>
    <v-dialog
      v-model="dialog_range"
      persistent
      width="600px"
    >
      <v-card class="neu-glow pb-1">
        <v-card-title>
          Scegli Periodo
          <v-spacer></v-spacer>            
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_range=false;recalc()">
                <v-icon color="info">mdi-check</v-icon>
              </v-btn>
            </template>
            <span>OK</span>
          </v-tooltip>           
        </v-card-title>
        <v-card class="neu-glow ma-4">
          <v-date-picker
            v-model="dateRange"
            scrollable
            range
            color="info"
            show-adjacent-months
            full-width
            :first-day-of-week="1"
            locale="it"
            show-week
          >
          </v-date-picker>
        </v-card>
      </v-card>
    </v-dialog>    
    <v-dialog v-model="dialog_summary" class="neu-glow" max-width="900" v-if="itemsAnalysis">
        <v-card class="neu-glow">
            <v-card-title class="text-h5 mb-3"
            >
              Riepilogo Messaggi {{new Intl.DateTimeFormat('it-IT',{ month:'long',year:'numeric' }).format(new Date(dateRange[0]))}}
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_summary = false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Chiudi</span>
              </v-tooltip>               
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5 mt-1 mb-0 pb-3">
              <v-col cols="12">
                <v-data-table
                  dense
                  class="pa-2 neu"
                  fixed-header
                  :headers="headers3"
                  :items="getDistinctTypes(itemsAnalysis)||[]"
                  hide-default-footer
                  :items-per-page=50000
                  :loading="loading" 
                  multi-sort
                  no-data-text="Nessun dato presente in archivio"
                  no-results-text="Nessun Risultato estratto"
                  loading-text="Consultazione archivio: attendi..."
                  item-key="messageId"
                >
                </v-data-table>
              </v-col>
            </v-row>
        </v-card>
    </v-dialog>    

    <v-snackbar v-model="snackbar.active"
      top
      timeout="2000"
      class=""
      :color="snackbar.color"
    >
      {{snackbar.text}}
    </v-snackbar>          
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      page: "WhatsApp",
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      dialog_edit:false,
      dialog_range:false,
      dialog_summary:false,
      loading_summary:false,
      snackbar:{active:false,color:'success',text:''},
      reviews:null,
      reviewsTA:null,
      reviewsG:null,
      loading:false,
      expanded:false,
      expandedTA:false,
      expandedG:false,
      search:null,
      searchTA:null,
      searchG:null,
      tab:null,
      items:null,
      itemsAnalysis:null,
      expired:null,
      dateRange:[new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().substring(0, 10),new Date().toISOString().substring(0, 10)],
      editedItem:{bookingId:null,reviewPrize:null,reviewPrizeValidUntil:null,prizeSpent:null,active:false,message:null},
      emptyItem: {bookingId:null,reviewPrize:null,reviewPrizeValidUntil:null,prizeSpent:null,active:false,message:null},
      dows:[
            {code:1,it:'Lunedì',en:'Mondays'},
            {code:2,it:'Martedì',en:'Tuesdays'},
            {code:3,it:'Mercoledì',en:'Wednsdays'},
            {code:4,it:'Giovedì',en:'Thursdays'},
            {code:5,it:'Venerdì',en:'Fridays'},
            {code:6,it:'Sabato',en:'Saturdays'},
            {code:7,it:'Domenica',en:'Sundays'}
           ],      
      headers: [
                { text: 'Numero',       value: 'recipientId', align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Name',         value: 'lastName',    align: 'start',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Giorno',       value: 'date',        align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Ora',          value: 'time',        align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Classe',       value: 'category',    align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Tipo',         value: 'type',        align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Status',       value: 'statusIcon',  align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Prenotazione',       value: 'bookingDate',  align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },

                /*
                { text: 'Inviato',      value: 'sent',     align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Consegnato',   value: 'delivered',       align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Letto',        value: 'read',    align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Fallito',      value: 'failed',       align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                */
                { text: 'N. Messaggio',  value: 'rn', align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                //{ text: 'Fatturabile', value: 'billable', align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                //{ text: 'Costo',         value: 'amount',       align: 'end',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                //{ text: 'Progressivo',   value: 'progressiveAmount',       align: 'end',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
              ],
      headers2: [
                { text: 'Numero',       value: 'recipient_id', align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                //{ text: 'Name',         value: 'lastName',    align: 'start',   sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Giorno',       value: 'date',        align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Ora',          value: 'time',        align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Classe',       value: 'category',    align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Tipo',         value: 'type',        align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Status',       value: 'status',      align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Conv.',        value: 'conversation_id',      align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Progr.',       value: 'seq',          align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Fatturabile',  value: 'payable',    align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
              ],
      headers3: [
                { text: 'Tipo',         value: 'type',        align: 'start',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Categoria',    value: 'category',    align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Inviati',      value: 'cnt',         align: 'end',     sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Fatturabili',  value: 'tot',         align: 'end',     sortable: true, class:'px-1 text-lg-button font-weight-black' }
              ],                            
      headersSMS: [
                { text: 'Numero',       value: 'fullPhone',     align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Name',         value: 'fullName',      align: 'start',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Giorno',       value: 'TS',  align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Invio',        value: 'sentTime',        align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Consegna',     value: 'deliveryTime',  align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                //{ text: 'Ritardo (s)',  value: 'delay',    align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Tipo',         value: 'type',        align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                //{ text: 'Status',       value: 'statusIcon',  align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Status',       value: 'status',  align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                //{ text: 'Error',  value: 'errorName', align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Canale', value: 'origin', align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' }
              ],
      templateTypes:["booking_cancelled","booking_confirmed","booking_confirmed_from_wl","booking_denied","booking_directions","booking_ireview_request","booking_link_booking","booking_link_edit","booking_modified","booking_recall_notification","booking_reminder","booking_review_request","booking_unconfirmed","booking_unconfirmed_notification","booking_verify_booking_status","booking_waiting_list","booking_waitlisted_notification"],                                                           
    };
  },
  computed : {
    ...mapGetters(["settings"]),
    rangeString: function()
    {
      console.log(260,this.dateRange)
      const options={ year: 'numeric', month: '2-digit', day: '2-digit' };
      return new Date(this.dateRange[0]).toLocaleDateString('it', options) + ' - ' + new Date(this.dateRange[1]).toLocaleDateString('it', options)
    }
  },
  created(){
    
    this.getData()
  },
  watch:
  {
    tab(newValue,oldValue)
    {
      this.search=null;
      console.log(476,newValue,oldValue);
      if(newValue==1)
      {
        this.getAnalysisWA()
      }
      if(newValue==0&&!oldValue)
      {
        this.getData()
      }
    }/*
    'editedItem.prizeSpent': function (newVal,oldVal)
    {
      if(oldVal)
      {
        if(newVal==1)
          this.editedItem.prizeSpent=this.editedItem.prizeSpentCopy
        else
          this.editedItem.prizeSpent=null
        console.log(386,this.editedItem)
      }
    }*/
    /*
    dateRange(newValue,oldValue)
    {
      console.log(293,newValue,oldValue)
      if(newValue!=oldValue)
      {
        this.getData()
      }
    }*/
  },
  methods:
  {
    recalc()
    {
      console.log(564,this.tab)
      if (this.tab==0)
      {
        this.getData()
      }
      else
      {
        this.getAnalysisWA()
      }
    },
    getDistinctTypes(data) {
      //this.loading_summary=true;
      const typeMap = new Map();
      let totalCnt = 0, totalTot = 0;

      data.forEach(item => {
          if (!typeMap.has(item.type)) {
              typeMap.set(item.type, { type: item.type, category: item.category, cnt: item.cnt, tot: item.tot });
              totalCnt += item.cnt;
              totalTot += item.tot;
          }
      });

      const w=Array.from(typeMap.values());
      w.push({ type: "TOTALI", category:'', cnt: totalCnt, tot: totalTot });
      //this.loading_summary=false;
      return w;
    },    
    customSearch (value, search, item) {
          return Object.values(item).some(v=>v&&v.toString().toLowerCase().includes(search.toLowerCase()))
      },
    async getData()
    {
        {
            this.loading=true;
            //try{
                const payload=JSON.stringify({"dateRange": this.dateRange,"action":"WA_messages_get"});
                const res = await this.$http.post('/whatsapp/whatsapp.php', payload );
                console.log(126,res);
                this.loading= false;
                switch (res.data.errorid)
                {
                  case '0':
                      console.log(761,this.settings)
                      //document.title = this.settings.username+' | '+this.page;
                      sessionStorage.setItem('jwt', res.data.jwt);
                      this.items=res.data.payloads.items;
                      this.expired=res.data.payloads.expired;
                      console.log(132,this.items);
                  break;
                  case '0006':
                      this.$router.push('/auth/login').catch(() => {});
                  break;
                }
                this.loading= false;
            /*} catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }*/
        }
    },
    async getAnalysisWA()
    {
        {
            this.loading=true;
            //try{
                const payload=JSON.stringify({"dateRange": this.dateRange,"action":"WA_messages_analysis_get"});
                const res = await this.$http.post('/whatsapp/whatsapp.php', payload );
                console.log(126,res);
                this.loading= false;
                switch (res.data.errorid)
                {
                  case '0':
                      console.log(761,this.settings)
                      //document.title = this.settings.username+' | '+this.page;
                      sessionStorage.setItem('jwt', res.data.jwt);
                      this.itemsAnalysis=res.data.payloads;
                      //this.expired=res.data.payloads.expired;
                      console.log(573,this.itemsAnalysis);
                  break;
                  case '0006':
                      this.$router.push('/auth/login').catch(() => {});
                  break;
                }
                this.loading= false;
            /*} catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }*/
        }
    },    
    async updateDB(payload){
        try{
            const res = await this.$http.post('/review/review.php', payload);
            console.log(127,res);
            if (res.data.errorid=='0')
            {
              sessionStorage.setItem('jwt', res.data.jwt);
              if (res.data.payloads)
              {
                  console.log(133);
                  //this.snackbar=true;
              }
            }
            else
            {
              console.log(139);
              //this.$router.push('/auth/login').catch(() => {});
            }
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    },    
  },
};
</script>
<style scoped>
.v-data-table__mobile-row{
  min-height: 24px!important;
}
</style>